import { z } from 'zod';

const infoBuyerAdReply = z.object({
    userId: z.string(),
    email: z.string(),
    name: z.string(),
    forwardPhone: z.boolean().optional(),
    phone: z.string().optional(),
});
const infoAdReply = z.object({
    email: z.string(),
    name: z.string(),
    body: z.string(),
    cc: z.boolean(),
    acceptTermsConds: z.boolean(),
    phone: z.string().optional(),
    forwardPhone: z.boolean().optional(),
});
const buyerInfoAdReply = z.object({
    buyerInfo: infoBuyerAdReply.optional(),
});
const adReply = z.object({
    reply: infoAdReply.optional(),
});
z.object({
    name: z.string(),
    body: z.string(),
    accept_terms_conds: z.boolean(),
    forward_phone: z.boolean().optional(),
    phone: z.string().optional(),
});

export { adReply, buyerInfoAdReply, infoAdReply, infoBuyerAdReply };
//# sourceMappingURL=zod.js.map
